// RoundTimer.js
import React, { useEffect, useState } from "react";

export default function RoundTimer({ durationSeconds, startedAt, onExpire }) {
  const [remaining, setRemaining] = useState(durationSeconds);

  useEffect(() => {
    if (!startedAt) return;

    const start = new Date(startedAt).getTime();
    const end = start + durationSeconds * 1000;

    const tick = () => {
      const now = Date.now();
      const diff = Math.max(0, Math.round((end - now) / 1000));
      setRemaining(diff);
      if (diff <= 0 && onExpire) onExpire();
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [durationSeconds, startedAt, onExpire]);

  const minutes = String(Math.floor(remaining / 60)).padStart(2, "0");
  const seconds = String(remaining % 60).padStart(2, "0");

  return (
    <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 bg-black/40 text-white text-xs sm:text-sm">
      <span className="inline-block w-2 h-2 rounded-full bg-red-500 animate-pulse" />
      <span>Round ends in {minutes}:{seconds}</span>
    </div>
  );
}